// src/pages/TeachersPage/TeachersPage.jsx
import React from "react";
import { PageContainer } from "../../components/layout";
import { TeacherManagement } from "./components";
import styles from "./TeachersPage.module.css";

const TeachersPage = () => {
	return (
		<PageContainer className={styles.teachersPage}>
			<TeacherManagement />
		</PageContainer>
	);
};

export default TeachersPage;
